import {EventEmitter, inject, Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {LookinChatSDK} from '../../../chat-sdk/src';
import {environment} from '../../environments/environment';
import {Group} from '../../../chat-sdk/src/entities/groups/group';
import {MessageContent} from '../../../chat-sdk/src/entities/messages/messageContent';
import {UserModelService} from '../models/user-model.service';
import {Worker} from '../entities/worker.entity';
import {IGroupRequestChangeResponse} from '../../../chat-sdk/src/interfaces/socket.interface';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  data: any[] = [];
  chat: LookinChatSDK;
  chatLoading = true;
  onGroupChange = new EventEmitter();

  constructor() {
  }

  initChat(user: Worker, worker: Worker, token: string) {
    const map = {
      79159999991: {
        token: 'token_1',
        userId: 2,
        workerId: 2,
      },
      79159999992: {
        token: 'token_2',
        userId: 2,
        workerId: 2,
      },
      79159999993: {
        token: 'token_3',
        userId: 3,
        workerId: 3,
      }
    };

    console.log('LookinChatSDK.connect');

    LookinChatSDK.connect({
      // id: map[user.username].userId,
      // workerId: map[user.username].workerId,
      id: user.id,
      workerId: worker.id,
    }, {
      socketUrl: environment.socketUrl,
      uploadUrl: environment.uploadUrl,
      sakuraUploadUrl: environment.baseUrl + environment.publicUrl,
      sakuraUrl: environment.baseUrl,
      // userToken: map[user.username].token,
      userToken: token,
    }).then(async (chat) => {
      this.chat = chat;
      console.log({chat});
      this.chat.registerOnGroupsUpdate((items) => {
        this.onChatGroupsUpdate(items);
      });
    });
  }

  onChatGroupsUpdate(items: IGroupRequestChangeResponse[]) {
    this.onGroupChange.emit();
  }

  disconnectChat() {
    LookinChatSDK.disconnect();
  }
}
